import { useEffect, useState } from 'react';
import { react2angular } from 'react2angular';
import TabBar from '@splunk/react-ui/TabBar';
import { ThemeProvider } from '@splunk/olly-common';
import { useLegacyThemeServiceKey } from '../../../common/theme/ThemeProvider';

const Routes = {
    ALERTS: 'alerts',
    DETECTORS: 'detectors',
    SLO: 'slo',
    DETECTOR_MUTING: 'muting',
};

const NAV_ITEMS = [
    {
        id: Routes.ALERTS,
        label: 'Active alerts',
        path: `/${Routes.ALERTS}/:orgId`,
        track: 'alert-tab-active-alerts',
    },
    {
        id: Routes.DETECTORS,
        label: 'Detectors',
        path: `/${Routes.DETECTORS}/:orgId`,
        track: 'alert-tab-detectors',
    },
    {
        id: Routes.SLO,
        label: 'Service level objectives',
        path: `/${Routes.SLO}`,
        track: 'alert-tab-slo',
    },
    {
        id: Routes.DETECTOR_MUTING,
        label: 'Muting rules',
        path: `/${Routes.DETECTOR_MUTING}/:orgId`,
        track: 'alert-tab-muting',
    },
];

const defaultEnabledTabs = {
    alerts: true,
    detectors: true,
    slo: true,
    muting: true,
};

const AlertTabs = ({ selected, currentUser, userAnalytics, showMutingRulesTab }) => {
    const colorScheme = useLegacyThemeServiceKey();
    const [orgId, setOrgId] = useState('');
    const enabledTabs = {
        ...defaultEnabledTabs,
        muting: showMutingRulesTab,
    };

    const navItems = NAV_ITEMS.filter((item) => enabledTabs[item.id]);

    const handleClick = (event, { selectedTabId }) => {
        const { track } = navItems.find(({ id }) => id === selectedTabId);
        userAnalytics.event('click', track);
    };

    useEffect(() => {
        currentUser.orgId().then(setOrgId);
    }, [currentUser, setOrgId]);

    return (
        <ThemeProvider colorScheme={colorScheme}>
            <TabBar activeTabId={selected} onChange={handleClick}>
                {navItems.map((item) => (
                    <TabBar.Tab
                        key={item.id}
                        tabId={item.id}
                        label={item.label}
                        to={`#${item.path.replace(':orgId', orgId)}`}
                    />
                ))}
            </TabBar>
        </ThemeProvider>
    );
};

/** filters name is bound as a way to force react component rerender whenever filters are updated and url params changes */
angular
    .module('signalview.alerts')
    .component(
        'alertTabs',
        react2angular(
            AlertTabs,
            ['selected', 'filters', 'showMutingRulesTab'],
            ['currentUser', 'userAnalytics']
        )
    );
